var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C4C4C4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.13,23.22l-3.24,3.08V13.05c0-0.51-0.42-0.93-0.93-0.93c-0.51,0-0.93,0.42-0.93,0.93v13.25l-3.24-3.08 c-0.37-0.35-0.96-0.34-1.31,0.03c-0.35,0.37-0.34,0.96,0.03,1.31l4.8,4.56c0.02,0.02,0.04,0.03,0.06,0.05 c0.02,0.02,0.04,0.04,0.06,0.05c0.03,0.02,0.06,0.04,0.09,0.05c0.02,0.01,0.04,0.02,0.07,0.03c0.04,0.02,0.08,0.02,0.11,0.03 c0.02,0.01,0.04,0.01,0.06,0.02c0.06,0.01,0.12,0.02,0.18,0.02s0.12-0.01,0.18-0.02c0.02,0,0.04-0.01,0.06-0.02 c0.04-0.01,0.08-0.02,0.11-0.03c0.02-0.01,0.04-0.02,0.07-0.03c0.03-0.02,0.06-0.03,0.09-0.05c0.02-0.01,0.04-0.03,0.06-0.05 c0.02-0.02,0.04-0.03,0.06-0.05l4.8-4.56c0.37-0.35,0.39-0.94,0.03-1.31C21.09,22.88,20.5,22.86,20.13,23.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.97,16.94l-4.8-4.56c-0.02-0.02-0.04-0.03-0.06-0.05c-0.02-0.02-0.04-0.04-0.06-0.05 c-0.03-0.02-0.06-0.04-0.09-0.05c-0.02-0.01-0.04-0.02-0.07-0.03c-0.04-0.02-0.08-0.02-0.11-0.03c-0.02-0.01-0.04-0.01-0.06-0.02 c-0.06-0.01-0.12-0.02-0.18-0.02c-0.06,0-0.12,0.01-0.18,0.02c-0.02,0-0.04,0.01-0.06,0.02c-0.04,0.01-0.08,0.02-0.11,0.03 c-0.02,0.01-0.04,0.02-0.07,0.03c-0.03,0.02-0.06,0.03-0.09,0.05c-0.02,0.01-0.04,0.03-0.06,0.05c-0.02,0.02-0.04,0.03-0.06,0.05 l-4.8,4.56c-0.37,0.35-0.39,0.94-0.03,1.31c0.35,0.37,0.94,0.39,1.31,0.03l3.24-3.08v13.25c0,0.51,0.42,0.93,0.93,0.93 s0.93-0.42,0.93-0.93V15.21l3.24,3.08c0.37,0.35,0.96,0.34,1.31-0.03C31.36,17.88,31.34,17.29,30.97,16.94z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon_8.42b3bf63215322d0b2fb24db4604f3f4.svg";
export { ForwardRef as ReactComponent };